import { Component, OnInit } from '@angular/core';
import { ClientesService } from 'src/app/services/clientes.service';
import { LoginService } from 'src/app/services/login.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-mis-pagos',
  templateUrl: './mis-pagos.component.html',
  styleUrls: ['./mis-pagos.component.scss']
})
export class MisPagosComponent implements OnInit {
  active = 1;
  pagos = [
    {'fecha':'2020-03-10', 'monto':'750', 'forma_pago':'Efectivo', 'tipo_pago':'Cuadros'},
    {'fecha':'2020-04-10', 'monto':'750', 'forma_pago':'Efectivo', 'tipo_pago':'Cuadros'},
  ]
  dataUsuario;
  respuestaPagos:any;
  respuestaGet:any;
  total = 1500;
  totalCliente = 0;
  saldo = 0;
  clienteid;
  datos_grupo;
  datosCliente;
  
  url = environment.BASE_URL

  constructor(private _getPagos:ClientesService, private _get:LoginService) { }
  
  ngOnInit(): void {
    this.getDataCliente();
  }

  getDataCliente(){
    console.log('entraaaaa');
    this._get.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
          this.clienteid = this.datosCliente.id;
          // alert(this.clienteid);
          this.getPagos(this.clienteid);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

  getPagos(cliente){
    this.dataUsuario = {
      'usuario':cliente
    }
    this._getPagos.getPagos(this.dataUsuario).subscribe(
      data => {
        this.respuestaPagos = data;
        if(this.respuestaPagos.success){
          this.pagos = this.respuestaPagos.content;
          this.total = this.respuestaPagos.total;
          this.totalCliente = this.respuestaPagos.compraMonto;
          this.saldo = this.respuestaPagos.saldo;
          this.clienteid = this.respuestaPagos.usuarioid;
          this.datos_grupo = this.respuestaPagos.datos_pagos;
          document.getElementById('click').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

}
